/*!
 * 
 *   @bornfight/gocart v1.0.9
 *   
 * 
 *   Copyright (c) Bornfight (https://www.bornfight.com/)
 * 
 *   This source code is licensed under the MIT license found in the
 *   LICENSE file in the root directory of this source tree.
 *   
 */

! function(t, e) {
    "object" === typeof exports && "object" === typeof module ? module.exports = e() : "function" === typeof define && define.amd ? define("GoCart", [], e) : "object" === typeof exports ? exports.GoCart = e() : t.GoCart = e()
  }(window, (function() {
    return function(t) {
        var e = {};
  
        function __webpack_require__(r) {
            if (e[r]) return e[r].exports;
            var a = e[r] = {
                i: r,
                l: !1,
                exports: {}
            };
            return t[r].call(a.exports, a, a.exports, __webpack_require__), a.l = !0, a.exports
        }
        return __webpack_require__.m = t, __webpack_require__.c = e, __webpack_require__.d = function(t, e, r) {
            __webpack_require__.o(t, e) || Object.defineProperty(t, e, {
                enumerable: !0,
                get: r
            })
        }, __webpack_require__.r = function(t) {
            "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(t, "__esModule", {
                value: !0
            })
        }, __webpack_require__.t = function(t, e) {
            if (1 & e && (t = __webpack_require__(t)), 8 & e) return t;
            if (4 & e && "object" === typeof t && t && t.__esModule) return t;
            var r = Object.create(null);
            if (__webpack_require__.r(r), Object.defineProperty(r, "default", {
                    enumerable: !0,
                    value: t
                }), 2 & e && "string" != typeof t)
                for (var a in t) __webpack_require__.d(r, a, function(e) {
                    return t[e]
                }.bind(null, a));
            return r
        }, __webpack_require__.n = function(t) {
            var e = t && t.__esModule ? function() {
                return t.default
            } : function() {
                return t
            };
            return __webpack_require__.d(e, "a", e), e
        }, __webpack_require__.o = function(t, e) {
            return Object.prototype.hasOwnProperty.call(t, e)
        }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = 1)
    }([function(t, e, r) {
        var a = r(3),
            o = /^(?:submit|button|image|reset|file)$/i,
            n = /^(?:input|select|textarea|keygen)/i,
            i = /(\[[^\[\]]*\])/g;
  
        function hash_serializer(t, e, r) {
            if (e.match(i)) {
                ! function hash_assign(t, e, r) {
                    if (0 === e.length) return t = r;
                    var a = e.shift(),
                        o = a.match(/^\[(.+?)\]$/);
                    if ("[]" === a) return t = t || [], Array.isArray(t) ? t.push(hash_assign(null, e, r)) : (t._values = t._values || [], t._values.push(hash_assign(null, e, r))), t;
                    if (o) {
                        var n = o[1],
                            i = +n;
                        isNaN(i) ? (t = t || {})[n] = hash_assign(t[n], e, r) : (t = t || [])[i] = hash_assign(t[i], e, r)
                    } else t[a] = hash_assign(t[a], e, r);
                    return t
                }(t, function(t) {
                    var e = [],
                        r = new RegExp(i),
                        a = /^([^\[\]]*)/.exec(t);
                    for (a[1] && e.push(a[1]); null !== (a = r.exec(t));) e.push(a[1]);
                    return e
                }(e), r)
            } else {
                var a = t[e];
                a ? (Array.isArray(a) || (t[e] = [a]), t[e].push(r)) : t[e] = r
            }
            return t
        }
  
        function str_serialize(t, e, r) {
            return r = r.replace(/(\r)?\n/g, "\r\n"), r = (r = encodeURIComponent(r)).replace(/%20/g, "+"), t + (t ? "&" : "") + encodeURIComponent(e) + "=" + r
        }
        t.exports = function(t, e) {
            "object" != a(e) ? e = {
                hash: !!e
            } : void 0 === e.hash && (e.hash = !0);
            for (var r = e.hash ? {} : "", i = e.serializer || (e.hash ? hash_serializer : str_serialize), s = t && t.elements ? t.elements : [], c = Object.create(null), l = 0; l < s.length; ++l) {
                var u = s[l];
                if ((e.disabled || !u.disabled) && u.name && (n.test(u.nodeName) && !o.test(u.type))) {
                    var d = u.name,
                        f = u.value;
                    if ("checkbox" !== u.type && "radio" !== u.type || u.checked || (f = void 0), e.empty) {
                        if ("checkbox" !== u.type || u.checked || (f = ""), "radio" === u.type && (c[u.name] || u.checked ? u.checked && (c[u.name] = !0) : c[u.name] = !1), void 0 == f && "radio" == u.type) continue
                    } else if (!f) continue;
                    if ("select-multiple" !== u.type) r = i(r, d, f);
                    else {
                        f = [];
                        for (var h = u.options, y = !1, p = 0; p < h.length; ++p) {
                            var m = h[p],
                                b = e.empty && !m.value,
                                v = m.value || b;
                            m.selected && v && (y = !0, r = e.hash && "[]" !== d.slice(d.length - 2) ? i(r, d + "[]", m.value) : i(r, d, m.value))
                        }!y && e.empty && (r = i(r, d, ""))
                    }
                }
            }
            if (e.empty)
                for (var d in c) c[d] || (r = i(r, d, ""));
            return r
        }
    }, function(t, e, r) {
        t.exports = r(4)
    }, function(t, e, r) {}, function(t, e) {
        function _typeof2(t) {
            return (_typeof2 = "function" === typeof Symbol && "symbol" === typeof Symbol.iterator ? function(t) {
                return typeof t
            } : function(t) {
                return t && "function" === typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
            })(t)
        }
  
        function _typeof(e) {
            return "function" === typeof Symbol && "symbol" === _typeof2(Symbol.iterator) ? t.exports = _typeof = function(t) {
                return _typeof2(t)
            } : t.exports = _typeof = function(t) {
                return t && "function" === typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof2(t)
            }, _typeof(e)
        }
        t.exports = _typeof
    }, function(t, e, r) {
        "use strict";
        r.r(e);
        r(2);
        var a = "${{amount}}";
  
        function formatMoney(t, e) {
//           console.log(currency.symbol);
         
            "string" === typeof t && (t = t.replace(".", ""));
            var r = "",
                o = /\{\{\s*(\w+)\s*\}\}/,
                n = e || a;
  
            function formatWithDelimiters(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 2,
                    r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : ",",
                    a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : ".";
                if (isNaN(t) || null == t) return 0;
                var o = (t = (t / 100).toFixed(e)).split(".");
                return o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1".concat(r)) + (o[1] ? a + o[1] : "")
            }
            switch (n.match(o)[1]) {
                case "amount":
                    r = formatWithDelimiters(t, 2);
                    break;
                case "amount_no_decimals":
                    r = formatWithDelimiters(t, 0);
                    break;
                case "amount_with_comma_separator":
                    r = formatWithDelimiters(t, 2, ".", ",");
                    break;
                case "amount_no_decimals_with_comma_separator":
                    r = formatWithDelimiters(t, 0, ".", ",")
            }
            return n.replace(o, r)
        }
  
        function formatOptions(json_item) {
          let options = json_item.options_with_values
          let sizeOption = ''
          let notSizeOptions = []
          options.forEach(option => {
//               if (option.name.toLowerCase() == 'size') {
//                   sizeOption = `${option.name}: ${option.value}`
//               } else {
//                   notSizeOptions.push(option.value)
//               }
             notSizeOptions.push(option.value)
          })
          if (sizeOption != '') {
              notSizeOptions.unshift(sizeOption)
          }
          return notSizeOptions.join(' / ')
       }
  
        function _typeof(t) {
            return (_typeof = "function" === typeof Symbol && "symbol" === typeof Symbol.iterator ? function(t) {
                return typeof t
            } : function(t) {
                return t && "function" === typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
            })(t)
        }
        var o = "undefined" !== typeof globalThis && globalThis || "undefined" !== typeof self && self || "undefined" !== typeof o && o,
            n = {
                searchParams: "URLSearchParams" in o,
                iterable: "Symbol" in o && "iterator" in Symbol,
                blob: "FileReader" in o && "Blob" in o && function() {
                    try {
                        return new Blob, !0
                    } catch (t) {
                        return !1
                    }
                }(),
                formData: "FormData" in o,
                arrayBuffer: "ArrayBuffer" in o
            };
        if (n.arrayBuffer) var i = ["[object Int8Array]", "[object Uint8Array]", "[object Uint8ClampedArray]", "[object Int16Array]", "[object Uint16Array]", "[object Int32Array]", "[object Uint32Array]", "[object Float32Array]", "[object Float64Array]"],
            s = ArrayBuffer.isView || function(t) {
                return t && i.indexOf(Object.prototype.toString.call(t)) > -1
            };
  
        function normalizeName(t) {
            if ("string" !== typeof t && (t = String(t)), /[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(t) || "" === t) throw new TypeError("Invalid character in header field name");
            return t.toLowerCase()
        }
  
        function normalizeValue(t) {
            return "string" !== typeof t && (t = String(t)), t
        }
  
        function iteratorFor(t) {
            var e = {
                next: function() {
                    var e = t.shift();
                    return {
                        done: void 0 === e,
                        value: e
                    }
                }
            };
            return n.iterable && (e[Symbol.iterator] = function() {
                return e
            }), e
        }
  
        function Headers(t) {
            this.map = {}, t instanceof Headers ? t.forEach((function(t, e) {
                this.append(e, t)
            }), this) : Array.isArray(t) ? t.forEach((function(t) {
                this.append(t[0], t[1])
            }), this) : t && Object.getOwnPropertyNames(t).forEach((function(e) {
                this.append(e, t[e])
            }), this)
        }
  
        function consumed(t) {
            if (t.bodyUsed) return Promise.reject(new TypeError("Already read"));
            t.bodyUsed = !0
        }
  
        function fileReaderReady(t) {
            return new Promise((function(e, r) {
                t.onload = function() {
                    e(t.result)
                }, t.onerror = function() {
                    r(t.error)
                }
            }))
        }
  
        function readBlobAsArrayBuffer(t) {
            var e = new FileReader,
                r = fileReaderReady(e);
            return e.readAsArrayBuffer(t), r
        }
  
        function bufferClone(t) {
            if (t.slice) return t.slice(0);
            var e = new Uint8Array(t.byteLength);
            return e.set(new Uint8Array(t)), e.buffer
        }
  
        function Body() {
            return this.bodyUsed = !1, this._initBody = function(t) {
                var e;
                this.bodyUsed = this.bodyUsed, this._bodyInit = t, t ? "string" === typeof t ? this._bodyText = t : n.blob && Blob.prototype.isPrototypeOf(t) ? this._bodyBlob = t : n.formData && FormData.prototype.isPrototypeOf(t) ? this._bodyFormData = t : n.searchParams && URLSearchParams.prototype.isPrototypeOf(t) ? this._bodyText = t.toString() : n.arrayBuffer && n.blob && ((e = t) && DataView.prototype.isPrototypeOf(e)) ? (this._bodyArrayBuffer = bufferClone(t.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : n.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(t) || s(t)) ? this._bodyArrayBuffer = bufferClone(t) : this._bodyText = t = Object.prototype.toString.call(t) : this._bodyText = "", this.headers.get("content-type") || ("string" === typeof t ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : n.searchParams && URLSearchParams.prototype.isPrototypeOf(t) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"))
            }, n.blob && (this.blob = function() {
                var t = consumed(this);
                if (t) return t;
                if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                if (this._bodyArrayBuffer) return Promise.resolve(new Blob([this._bodyArrayBuffer]));
                if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                return Promise.resolve(new Blob([this._bodyText]))
            }, this.arrayBuffer = function() {
                if (this._bodyArrayBuffer) {
                    var t = consumed(this);
                    return t || (ArrayBuffer.isView(this._bodyArrayBuffer) ? Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength)) : Promise.resolve(this._bodyArrayBuffer))
                }
                return this.blob().then(readBlobAsArrayBuffer)
            }), this.text = function() {
                var t = consumed(this);
                if (t) return t;
                if (this._bodyBlob) return function(t) {
                    var e = new FileReader,
                        r = fileReaderReady(e);
                    return e.readAsText(t), r
                }(this._bodyBlob);
                if (this._bodyArrayBuffer) return Promise.resolve(function(t) {
                    for (var e = new Uint8Array(t), r = new Array(e.length), a = 0; a < e.length; a++) r[a] = String.fromCharCode(e[a]);
                    return r.join("")
                }(this._bodyArrayBuffer));
                if (this._bodyFormData) throw new Error("could not read FormData body as text");
                return Promise.resolve(this._bodyText)
            }, n.formData && (this.formData = function() {
                return this.text().then(decode)
            }), this.json = function() {
                return this.text().then(JSON.parse)
            }, this
        }
        Headers.prototype.append = function(t, e) {
            t = normalizeName(t), e = normalizeValue(e);
            var r = this.map[t];
            this.map[t] = r ? r + ", " + e : e
        }, Headers.prototype.delete = function(t) {
            delete this.map[normalizeName(t)]
        }, Headers.prototype.get = function(t) {
            return t = normalizeName(t), this.has(t) ? this.map[t] : null
        }, Headers.prototype.has = function(t) {
            return this.map.hasOwnProperty(normalizeName(t))
        }, Headers.prototype.set = function(t, e) {
            this.map[normalizeName(t)] = normalizeValue(e)
        }, Headers.prototype.forEach = function(t, e) {
            for (var r in this.map) this.map.hasOwnProperty(r) && t.call(e, this.map[r], r, this)
        }, Headers.prototype.keys = function() {
            var t = [];
            return this.forEach((function(e, r) {
                t.push(r)
            })), iteratorFor(t)
        }, Headers.prototype.values = function() {
            var t = [];
            return this.forEach((function(e) {
                t.push(e)
            })), iteratorFor(t)
        }, Headers.prototype.entries = function() {
            var t = [];
            return this.forEach((function(e, r) {
                t.push([r, e])
            })), iteratorFor(t)
        }, n.iterable && (Headers.prototype[Symbol.iterator] = Headers.prototype.entries);
        var c = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
  
        function Request(t, e) {
            if (!(this instanceof Request)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            var r = (e = e || {}).body;
            if (t instanceof Request) {
                if (t.bodyUsed) throw new TypeError("Already read");
                this.url = t.url, this.credentials = t.credentials, e.headers || (this.headers = new Headers(t.headers)), this.method = t.method, this.mode = t.mode, this.signal = t.signal, r || null == t._bodyInit || (r = t._bodyInit, t.bodyUsed = !0)
            } else this.url = String(t);
            if (this.credentials = e.credentials || this.credentials || "same-origin", !e.headers && this.headers || (this.headers = new Headers(e.headers)), this.method = function(t) {
                    var e = t.toUpperCase();
                    return c.indexOf(e) > -1 ? e : t
                }(e.method || this.method || "GET"), this.mode = e.mode || this.mode || null, this.signal = e.signal || this.signal, this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && r) throw new TypeError("Body not allowed for GET or HEAD requests");
            if (this._initBody(r), ("GET" === this.method || "HEAD" === this.method) && ("no-store" === e.cache || "no-cache" === e.cache)) {
                var a = /([?&])_=[^&]*/;
                if (a.test(this.url)) this.url = this.url.replace(a, "$1_=" + (new Date).getTime());
                else {
                    this.url += (/\?/.test(this.url) ? "&" : "?") + "_=" + (new Date).getTime()
                }
            }
        }
  
        function decode(t) {
            var e = new FormData;
            return t.trim().split("&").forEach((function(t) {
                if (t) {
                    var r = t.split("="),
                        a = r.shift().replace(/\+/g, " "),
                        o = r.join("=").replace(/\+/g, " ");
                    e.append(decodeURIComponent(a), decodeURIComponent(o))
                }
            })), e
        }
  
        function parseHeaders(t) {
            var e = new Headers;
            return t.replace(/\r?\n[\t ]+/g, " ").split(/\r?\n/).forEach((function(t) {
                var r = t.split(":"),
                    a = r.shift().trim();
                if (a) {
                    var o = r.join(":").trim();
                    e.append(a, o)
                }
            })), e
        }
  
        function Response(t, e) {
            if (!(this instanceof Response)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            e || (e = {}), this.type = "default", this.status = void 0 === e.status ? 200 : e.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in e ? e.statusText : "", this.headers = new Headers(e.headers), this.url = e.url || "", this._initBody(t)
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            })
        }, Body.call(Request.prototype), Body.call(Response.prototype), Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            })
        }, Response.error = function() {
            var t = new Response(null, {
                status: 0,
                statusText: ""
            });
            return t.type = "error", t
        };
        var l = [301, 302, 303, 307, 308];
        Response.redirect = function(t, e) {
            if (-1 === l.indexOf(e)) throw new RangeError("Invalid status code");
            return new Response(null, {
                status: e,
                headers: {
                    location: t
                }
            })
        };
        var u = o.DOMException;
        try {
            new u
        } catch (y) {
            (u = function(t, e) {
                this.message = t, this.name = e;
                var r = Error(t);
                this.stack = r.stack
            }).prototype = Object.create(Error.prototype), u.prototype.constructor = u
        }
  
        function fetch(t, e) {
            return new Promise((function(r, a) {
                var i = new Request(t, e);
                if (i.signal && i.signal.aborted) return a(new u("Aborted", "AbortError"));
                var s = new XMLHttpRequest;
  
                function abortXhr() {
                    s.abort()
                }
                s.onload = function() {
                    var t = {
                        status: s.status,
                        statusText: s.statusText,
                        headers: parseHeaders(s.getAllResponseHeaders() || "")
                    };
                    t.url = "responseURL" in s ? s.responseURL : t.headers.get("X-Request-URL");
                    var e = "response" in s ? s.response : s.responseText;
                    setTimeout((function() {
                        r(new Response(e, t))
                    }), 0)
                }, s.onerror = function() {
                    setTimeout((function() {
                        a(new TypeError("Network request failed"))
                    }), 0)
                }, s.ontimeout = function() {
                    setTimeout((function() {
                        a(new TypeError("Network request failed"))
                    }), 0)
                }, s.onabort = function() {
                    setTimeout((function() {
                        a(new u("Aborted", "AbortError"))
                    }), 0)
                }, s.open(i.method, function(t) {
                    try {
                        return "" === t && o.location.href ? o.location.href : t
                    } catch (e) {
                        return t
                    }
                }(i.url), !0), "include" === i.credentials ? s.withCredentials = !0 : "omit" === i.credentials && (s.withCredentials = !1), "responseType" in s && (n.blob ? s.responseType = "blob" : n.arrayBuffer && i.headers.get("Content-Type") && -1 !== i.headers.get("Content-Type").indexOf("application/octet-stream") && (s.responseType = "arraybuffer")), !e || "object" !== _typeof(e.headers) || e.headers instanceof Headers ? i.headers.forEach((function(t, e) {
                    s.setRequestHeader(e, t)
                })) : Object.getOwnPropertyNames(e.headers).forEach((function(t) {
                    s.setRequestHeader(t, normalizeValue(e.headers[t]))
                })), i.signal && (i.signal.addEventListener("abort", abortXhr), s.onreadystatechange = function() {
                    4 === s.readyState && i.signal.removeEventListener("abort", abortXhr)
                }), s.send("undefined" === typeof i._bodyInit ? null : i._bodyInit)
            }))
        }
        fetch.polyfill = !0, o.fetch || (o.fetch = fetch, o.Headers = Headers, o.Request = Request, o.Response = Response);
        var d = r(0),
            f = r.n(d);

/*********************************
 * allsips — Gift Sync
 * 规则：
 *   - 满 $49 且购物车中没有 32oz 赠品（含 popup 版本）时，自动加赠 32oz
 **********************************/

(function(){
  const FREE_32OZ_BOTTLE = '53787468595497';
  const POPUP_FREE_32OZ_BOTTLE = '53780260847913';
  const GIFT_THRESHOLD_USD = 39;
  const GIFT_TEXT = 'Get a FREE Scent Pod + Exclusive Gym Bag with orders $39+';

  let __giftQueue = Promise.resolve();
  function queueGiftTask(task){
    __giftQueue = __giftQueue.then(task).catch(()=>{});
    return __giftQueue;
  }

  function getCartJSON(){
    return new Promise((resolve, reject) => {
      jQuery.getJSON('/cart.js').done(resolve).fail((xhr, err) => reject(err || 'cart.js failed'));
    });
  }

  function cartAdd(variantId, properties){
    const data = { quantity: 1, id: variantId };
    if (properties && typeof properties === 'object'){
      for (const k in properties) data[`properties[${k}]`] = properties[k];
    }
    return jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: jQuery.param(data),
      dataType: 'json'
    });
  }

  async function safeFetchCart(){
    try{
      if (window.goCart && typeof window.goCart.fetchCart === 'function'){
        await window.goCart.fetchCart();
      }else{
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }
    }catch(e){}
  }

  async function JNCO_syncGiftWithJQ(cart){
    return queueGiftTask(async () => {
      const currentCart = cart && Array.isArray(cart.items) ? cart : await getCartJSON();
      const rate = (window.Shopify && window.Shopify.currency && Number(window.Shopify.currency.rate)) || 1;
      const total_price_usd = Number(currentCart.total_price || 0) / 100 / rate;
      const cartItems = Array.isArray(currentCart.items) ? currentCart.items : [];

      const has_free32ozbottle = cartItems.find(item => Number(item.id) == Number(FREE_32OZ_BOTTLE));
      const has_popup32ozbottle = cartItems.find(item => Number(item.id) == Number(POPUP_FREE_32OZ_BOTTLE));

      if (total_price_usd >= GIFT_THRESHOLD_USD && !has_free32ozbottle && !has_popup32ozbottle) {
        await cartAdd(FREE_32OZ_BOTTLE, { _gift: GIFT_TEXT });
        await safeFetchCart();
      }
    });
  }

  window.JNCO_syncGiftWithJQ = JNCO_syncGiftWithJQ;
})();
// 进度条
function updateProgressBar(orderAmount) {
    const conversionRate = window.Shopify.currency.rate || 1;
    const shopCurrency = window.Shopify.currency.active || 'USD';
    const currencySymbols = {'AED':'د.إ','ARS':'$','AUD':'$','BGN':'лв','BRL':'R$','CAD':'$','CHF':'CHF','CLP':'$','CNY':'¥','COP':'$','CRC':'₡','CZK':'Kč','DKK':'kr','DOP':'RD$','EGP':'£','EUR':'€','GBP':'£','GEL':'₾','GTQ':'Q','HKD':'$','HNL':'L','HUF':'Ft','IDR':'Rp','ILS':'₪','INR':'₹','JPY':'¥','KHR':'៛','KRW':'₩','KWD':'د.ك','KZT':'₸','MAD':'د.م.','MXN':'$','MYR':'RM','NGN':'₦','NIO':'C$','NOK':'kr','NZD':'$','PEN':'S/','PHP':'₱','PKR':'₨','PLN':'zł','PYG':'₲','QAR':'ر.ق','RON':'lei','RSD':'дин','RUB':'₽','SAR':'﷼','SEK':'kr','SGD':'$','THB':'฿','TRY':'₺','TWD':'NT$','UAH':'₴','USD':'$','VES':'Bs','VND':'₫','ZAR':'R'};
    const currencySymbol = window.Shopify.currency.symbol || currencySymbols[shopCurrency] || '$';
    const country = window.Shopify.country || 'US';

    const FREE_SHIPPING_USD = country === 'US' ? 59 : 99;

    const thresholdLocalAmount = (FREE_SHIPPING_USD * conversionRate);
    const formatCurrency = (amount) => {
        const formatted = amount.toFixed(2);
        return formatted.replace('.', shopCurrency === 'EUR' ? ',' : '.');
    };
    const thresholdLocalDisplay = formatCurrency(thresholdLocalAmount);

    let progressPercentage = 0;
    let message = '';
    $(".tooltip-1").html(`Free Shipping (<span class="currency">${currencySymbol}${thresholdLocalDisplay}</span>)`);
    $(".tooltip-1").css("opacity", 0.3);
    $(".tooltip-2").hide();
    $(".marker-1-2").hide();

    if (orderAmount >= thresholdLocalAmount) {
        progressPercentage = 100;
        message = "Congrats! You’ve got free standard shipping!";
        $(".tooltip-1").css("opacity", 1);
        $(".marker").css("background", "white");
    } else {
        progressPercentage = (orderAmount / thresholdLocalAmount) * 100;
        const amountNeeded = formatCurrency(thresholdLocalAmount - orderAmount);
        message = `${currencySymbol}${amountNeeded} away from free standard shipping`;
        $(".marker").css("background", "black");
    }

    $(".progress-bar").css("width", `${progressPercentage}%`);
    $(".discount-info").text(message);
}




        function _defineProperties(t, e) {
            for (var r = 0; r < e.length; r++) {
                var a = e[r];
                a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, a.key, a)
            }
        }
        function parseGoCartJSON(t) {
            return t.text().then((function(e) {
                try {
                    return JSON.parse(e)
                } catch (r) {
                    var a = (e || "").replace(/\s+/g, " ").slice(0, 120),
                        o = t && t.status ? "HTTP ".concat(t.status, " ") : "",
                        n = t && t.url ? t.url : "cart endpoint";
                    throw new Error("Expected JSON from ".concat(n, " but received ").concat(o).concat(a || "an empty response"))
                }
            }))
        }
        var h = function() {
            function GoCart(t) {
                ! function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
                }(this, GoCart);
                this.defaults = Object.assign({}, {
                    bodyElement: "body",
                    htmlElement: "html",
                    cartModalFail: ".js-go-cart-modal-fail",
                    cartModalFailClose: ".js-go-cart-modal-fail-close",
                    cartModal: ".js-go-cart-modal",
                    cartModalClose: ".js-go-cart-modal-close",
                    cartModalContent: ".js-go-cart-modal-content",
                    cartDrawer: ".js-go-cart-drawer",
                    cartDrawerContent: ".js-go-cart-drawer-content",
                    cartDrawerSubTotal: ".js-go-cart-drawer-subtotal",
                    cartDrawerFooter: ".js-go-cart-drawer-footer",
                    cartDrawerClose: ".js-go-cart-drawer-close",
                    cartMiniCart: ".js-go-cart-mini-cart",
                    cartMiniCartContent: ".js-go-cart-mini-cart-content",
                    cartMiniCartSubTotal: ".js-go-cart-mini-cart-subtotal",
                    cartMiniCartFooter: ".js-go-cart-mini-cart-footer",
                    cartTrigger: ".js-go-cart-trigger",
                    cartOverlay: ".js-go-cart-overlay",
                    cartCount: ".js-go-cart-counter",
                    addToCart: ".js-go-cart-add-to-cart",
                    removeFromCart: ".js-go-cart-remove-from-cart",
                    removeFromCartNoDot: "js-go-cart-remove-from-cart",
                    itemQuantity: ".js-go-cart-quantity",
                    itemQuantityPlus: ".js-go-cart-quantity-plus",
                    itemQuantityMinus: ".js-go-cart-quantity-minus",
                    itemQuantityUpdate: ".js-go-cart-quantity-quantity-update",
                    cartMode: "drawer",
                    drawerDirection: "right",
                    displayModal: !1,
                    moneyFormat: currency.symbol + "{{amount}}" ,
                  moneyFormatSub: currency.symbol + "{{amount}} " + currency.code,
                    labelAddedToCart: "was added to your cart.",
                    labelCartIsEmpty: "Your Cart is currently empty!",
                    labelQuantity: "Quantity:",
                    labelRemove: "Remove"
                }, t), this.cartModalFail = document.querySelector(this.defaults.cartModalFail), this.bodyElement = document.querySelector(this.defaults.bodyElement), this.htmlElement = document.querySelector(this.defaults.htmlElement), this.cartModalFailClose = document.querySelector(this.defaults.cartModalFailClose), this.cartModal = document.querySelector(this.defaults.cartModal), this.cartModalClose = document.querySelectorAll(this.defaults.cartModalClose), this.cartModalContent = document.querySelector(this.defaults.cartModalContent), this.cartDrawer = document.querySelector(this.defaults.cartDrawer), this.cartDrawerContent = document.querySelector(this.defaults.cartDrawerContent), this.cartDrawerSubTotal = document.querySelector(this.defaults.cartDrawerSubTotal), this.cartDrawerFooter = document.querySelector(this.defaults.cartDrawerFooter), this.cartDrawerClose = document.querySelector(this.defaults.cartDrawerClose), this.cartMiniCart = document.querySelector(this.defaults.cartMiniCart), this.cartMiniCartContent = document.querySelector(this.defaults.cartMiniCartContent), this.cartMiniCartSubTotal = document.querySelector(this.defaults.cartMiniCartSubTotal), this.cartMiniCartFooter = document.querySelector(this.defaults.cartMiniCartFooter), this.cartTrigger = document.querySelector(this.defaults.cartTrigger), this.cartOverlay = document.querySelector(this.defaults.cartOverlay), this.cartCount = document.querySelector(this.defaults.cartCount), this.addToCart = document.querySelectorAll(this.defaults.addToCart), this.removeFromCart = this.defaults.removeFromCart, this.removeFromCartNoDot = this.defaults.removeFromCartNoDot, this.itemQuantity = this.defaults.itemQuantity, this.itemQuantityPlus = this.defaults.itemQuantityPlus, this.itemQuantityMinus = this.defaults.itemQuantityMinus,this.itemQuantityUpdate = this.defaults.itemQuantityUpdate, this.cartMode = this.defaults.cartMode, this.drawerDirection = this.defaults.drawerDirection, this.displayModal = this.defaults.displayModal, this.moneyFormat = this.defaults.moneyFormat, this.moneyFormatSub = this.defaults.moneyFormatSub, this.labelAddedToCart = this.defaults.labelAddedToCart, this.labelCartIsEmpty = this.defaults.labelCartIsEmpty, this.labelQuantity = this.defaults.labelQuantity, this.labelRemove = this.defaults.labelRemove, this.init()
            }
            var t, e, r;
            return t = GoCart, r = [{
                key: "removeItemAnimation",
                value: function(t) {
                    t.classList.add("is-invisible")
                }
            }], (e = [{
                key: "init",
                value: function() {
                    var t = this;
                    this.fetchCart(), this.isDrawerMode && this.setDrawerDirection();
                    let installmentForm = document.getElementById('product-form-installment');
                    if (installmentForm) {
                      addEventListener("submit", function(e) {
                          e.preventDefault();
                          var a = e.target.getAttribute("id");
//                         console.log("ID"+a);
                          t.addItemToCart(a)
                      }, false)
                    }
                    document.addEventListener("click", (function(e) {
                      
                        if (e.target.matches(t.defaults.addToCart)) {
                            e.preventDefault();
                            for (var r = e.target.parentNode;
                                "form" !== r.tagName.toLowerCase();) r = r.parentNode;
                            var a = r.getAttribute("id");
                            t.addItemToCart(a)
                        }
                    }), !1),
                    this.cartTrigger.addEventListener("click", (function(e) {
                      e.preventDefault();
                        t.isDrawerMode ? t.openCartDrawer() : t.openMiniCart(), t.openCartOverlay()
                    })), this.cartOverlay.addEventListener("click", (function() {
                        t.closeFailModal(), t.closeCartModal(), t.isDrawerMode ? t.closeCartDrawer() : t.closeMiniCart(), t.closeCartOverlay()
                    })), this.isDrawerMode && this.cartDrawerClose.addEventListener("click", (function() {
                        t.closeCartDrawer(), t.closeCartOverlay()
                    })), this.displayModal && this.cartModalClose.forEach((function(e) {
                        e.addEventListener("click", (function() {
                            t.closeFailModal(), t.closeCartModal(), t.isDrawerMode ? t.closeCartDrawer() : t.closeMiniCart(), t.closeCartOverlay()
                        }))
                    })), this.cartModalFailClose.addEventListener("click", (function() {
                        t.closeFailModal(), t.closeCartModal(), t.isDrawerMode ? t.closeCartDrawer() : t.closeMiniCart(), t.closeCartOverlay()
                    }))
                }
            }, {
                key: "fetchCart",
                value: function(t) {
                    var e = this;
                    window.fetch("/cart.js", {
                        credentials: "same-origin",
                        method: "GET"
                    }).then((function(t) {
                        return parseGoCartJSON(t)
                    })).then((function(r) {
                        return e.fetchHandler(r, t)
                    })).catch((function(t) {
                        e.ajaxRequestFail(), window.console && window.console.warn && window.console.warn("GoCart request failed", t)
                    }))
                }
            }, {
                key: "addItemToCart",
                value: function(t) {
//                   console.log(t);
                     
                      let productForm = document.querySelector('product-form.'+t);
                  if (!productForm) return;
                      
                      let form = productForm.querySelector('form');
                      const submitButton = productForm.querySelector('[type="submit"]');
                  const spinner = productForm.querySelector('.loading-overlay__spinner');
                  if (!form || !submitButton) return;
                      if (submitButton.classList.contains('loading')) return;
                      this.handleErrorMessage();
//                   console.log(form);
  
                      submitButton.setAttribute('aria-disabled', true);
                      submitButton.classList.add('loading');
                      if (spinner) spinner.classList.remove('hidden');
  
                  const config = fetchConfig('javascript');
                  config.headers['X-Requested-With'] = 'XMLHttpRequest';
                  delete config.headers['Content-Type'];
  
                  const formData = new FormData(form);
                  formData.append('sections_url', window.location.pathname);
//                   for(let [name, value] of formData) {
//                       console.log(`${name} = ${value}`); // key1 = value1, then key2 = value2
//                     }
                 
                  
                  config.body = formData;
                  let th = this;
                  
                    window.fetch("/cart/add.js", config)
                      .then((function(t) {
                        return parseGoCartJSON(t);
                      
                      })).then((function(t) {
                          if (t.status) {
                              th.handleErrorMessage(t.description);
                          } else {
                              return th.addItemToCartHandler(t)
                          }
                      })).catch((function(t) {
                          th.ajaxRequestFail(), window.console && window.console.warn && window.console.warn("GoCart request failed", t)
                          })).finally(() => {
                              submitButton.classList.remove('loading');
                              submitButton.removeAttribute('aria-disabled');
                              if (spinner) spinner.classList.add('hidden');     
                              $('.cart-title').text('Your Cart');
                              setTimeout(function () {
//                           $('.recomendation-outer').css('display','block');
                                 $('.cart_best_selling').css('display','none');
                                $('.recom_main').css('display','block');
                                if ($(window).width() < 767 ) {
                                  var recSlider = $('.recomendation-inner');
                                  if (recSlider.length && recSlider.hasClass('slick-initialized') && recSlider.get(0).slick) {
                                    recSlider.get(0).slick.setPosition();
                                  }
                                }
                            $('.footer-cart-drawer').css('display','block');                            
                             $('.go-cart-drawer__content').css('border-bottom','1px solid #999');
                             $('.go-cart-drawer__content').css('padding-bottom','20px');
                            $('.drawer-main').removeClass('main-drawer-empty');
                          }, 100);
                  
                        });
                }
            }, {
                    key: "handleErrorMessage",
                    value: function(errorMsg = false) {
                      let productForm = document.querySelector('product-form')
                  if (!productForm) return;
                      let errorMessageWrapper = productForm.querySelector('.product-form__error-message-wrapper');
                  if (!errorMessageWrapper) return;
//                   console.log('error message wrapper', errorMessageWrapper)
                      let errorMessage = errorMessageWrapper.querySelector('.product-form__error-message');
//                   console.log('error message', errorMessage)
            
                  errorMessageWrapper.toggleAttribute('hidden', !errorMsg);
                
                      if (errorMsg) {
                        if (errorMessage) errorMessage.textContent = errorMsg;
                      }
                    }
            }, {
                key: "removeItem",
                value: function(t) {
                    var e = this;
                    window.fetch("/cart/change.js", {
                        method: "POST",
                        credentials: "same-origin",
                        body: JSON.stringify({
                            quantity: 0,
                            line: t
                        }),
                        headers: {
                            "Content-Type": "application/json"
                        }
                    }).then((function(t) {
                        return parseGoCartJSON(t)
                    })).then((function() {
                        return e.fetchCart()
                    })).catch((function(t) {
                        e.ajaxRequestFail(), window.console && window.console.warn && window.console.warn("GoCart request failed", t)
                    }))
                }
            }, {
                key: "normalizeDuplicatePaidLines",
                value: function(t) {
                    function isGiftLine(t) {
                        return !!(t && t.properties && t.properties._gift !== undefined)
                    }
                    function isFreeLine(t) {
                        var e = "number" === typeof t.final_line_price ? t.final_line_price : t.line_price;
                        return Number(e || 0) === 0
                    }
                    function normalizedProperties(t) {
                        var e = t || {},
                            r = Object.keys(e).filter((function(t) {
                                return "_gift" !== t && null != e[t] && "" !== e[t]
                            })).sort(),
                            a = {};
                        return r.forEach((function(t) {
                            a[t] = e[t]
                        })), JSON.stringify(a)
                    }
                    function sellingPlanId(t) {
                        return t && t.selling_plan_allocation && t.selling_plan_allocation.selling_plan ? t.selling_plan_allocation.selling_plan.id || "" : ""
                    }
                    function groupKey(t) {
                        return [t.variant_id, sellingPlanId(t), normalizedProperties(t.properties)].join("|")
                    }
                    function firstDuplicateGroup(t) {
                        var e = {};
                        return (t.items || []).forEach((function(t, r) {
                            if (!isGiftLine(t) && !isFreeLine(t)) {
                                var a = groupKey(t);
                                e[a] || (e[a] = []), e[a].push({
                                    line: r + 1,
                                    item: t
                                })
                            }
                        })), Object.keys(e).map((function(t) {
                            return e[t]
                        })).find((function(t) {
                            return t.length > 1
                        }))
                    }
                    function changeLine(t, e) {
                        return window.fetch("/cart/change.js", {
                            method: "POST",
                            credentials: "same-origin",
                            body: JSON.stringify({
                                quantity: e,
                                line: t
                            }),
                            headers: {
                                "Content-Type": "application/json"
                            }
                        }).then((function(t) {
                            return parseGoCartJSON(t)
                        }))
                    }
                    function fetchCartJSON() {
                        return window.fetch("/cart.js", {
                            credentials: "same-origin",
                            method: "GET"
                        }).then((function(t) {
                            return parseGoCartJSON(t)
                        }))
                    }
                    function pass(t, e) {
                        var r = firstDuplicateGroup(t);
                        if (!r || e <= 0) return Promise.resolve(t);
                        var a = r[0],
                            o = r.reduce((function(t, e) {
                                return t + Number(e.item.quantity || 0)
                            }), 0),
                            n = r.slice(1).sort((function(t, e) {
                                return e.line - t.line
                            })),
                            i = Promise.resolve();
                        return n.forEach((function(t) {
                            i = i.then((function() {
                                return changeLine(t.line, 0)
                            }))
                        })), i.then((function() {
                            return changeLine(a.line, o)
                        })).then(fetchCartJSON).then((function(t) {
                            return pass(t, e - 1)
                        }))
                    }
                    return pass(t, 4).catch((function() {
                        return t
                    }))
                }
            }, {
                key: "changeItemQuantity",
                value: function(t, e) {
                    var r = this;
                    window.fetch("/cart/change.js", {
                        method: "POST",
                        credentials: "same-origin",
                        body: JSON.stringify({
                            quantity: e,
                            line: t
                        }),
                        headers: {
                            "Content-Type": "application/json"
                        }
                    }).then((function(t) {                      
                        return parseGoCartJSON(t)
                    })).then((function(t) {
                        return r.normalizeDuplicatePaidLines(t)
                    })).then((function(t) {
                        return r.fetchHandler(t)
                    })).catch((function(t) {
                        r.ajaxRequestFail(), window.console && window.console.warn && window.console.warn("GoCart request failed", t)
                    }))
                }
            }, {
                key: "cartItemCount",
                value: function(t) {
                    let d = t.item_count
                    function pad(d) {
                            return (d < 10 && d > 0) ? '0' + d.toString() : d.toString();
                    }
                    if (this.cartCount) this.cartCount.innerHTML = t.item_count
                    let drawerCountInner = document.querySelector('.drawer-caount-inner')
                    let cartCounter = document.querySelector('.js-go-cart-counter')
                    let bubbleEl = document.querySelector('.cart-count-bubble')
                    let drawerCountEl = document.querySelector('.drawer-count')
                    let footerDrawer = document.querySelector('.footer-cart-drawer')
                    if (drawerCountInner) drawerCountInner.innerHTML = pad(d)
                    if (cartCounter) cartCounter.innerHTML = pad(d)
                    let bubbleClasses = bubbleEl && bubbleEl.classList
                    let drawerCount = drawerCountEl && drawerCountEl.classList
                    if (t.item_count == 0) {
                      if (bubbleClasses) bubbleClasses.add('hidden');
                       if (drawerCount) drawerCount.add('hidden');
                    } else {
                      if (bubbleClasses) bubbleClasses.remove('hidden');
                      if (drawerCount) drawerCount.remove('hidden');
                       if (footerDrawer) footerDrawer.style.display = 'block';
                    }

   



            
                }
            }, {
                key: "fetchAndOpenCart",
                value: function() {
                    var t = this;
                    t.isDrawerMode ? t.openCartDrawer() : t.openMiniCart(), t.openCartOverlay();
                    this.fetchCart()
                }
            }, {
                key: "fetchAndOpenModal",
                value: function(t) {
                    var e = this;
                    this.fetchCart((function() {
                        e.renderCartModal(t), e.openCartModal(), e.openCartOverlay()
                    }))
                }
            }, {
                key: "fetchHandler",
                value: function(t, e) {
                 this.cartItemCount(t), this.isDrawerMode ? 0 === t.item_count ? (this.renderBlankCartDrawer(), this.cartDrawerFooter.classList.add("is-invisible")) : (this.renderDrawerCart(t), this.cartDrawerFooter.classList.remove("is-invisible"), "function" === typeof e && e(t)) : 0 === t.item_count ? (this.renderBlankMiniCart(), this.cartMiniCartFooter.classList.add("is-invisible")) : (this.renderMiniCart(t), this.cartMiniCartFooter.classList.remove("is-invisible"), "function" === typeof e && e(t))
                try {
                  if (typeof window.JNCO_syncGiftWithJQ === 'function') {
                    clearTimeout(window.__jncGiftTimer);
                    window.__jncGiftTimer = setTimeout(function () {
                      window.JNCO_syncGiftWithJQ(t);
                    }, 800);
                  }
                } catch (err) {}
                // ===== toggle recommend-wrapper-1111 =====
try {
  // 等本轮 DOM 更新完成
  requestAnimationFrame(function () {
    var el = document.getElementById('recommend-wrapper-1111');
    if (!el || !t) return;

    var TARGET_VARIANT_ID = 41422777778309;
    var items = t.items || [];
    var hasTarget = false;

    for (var i = 0; i < items.length; i++) {
      if (Number(items[i].variant_id) === Number(TARGET_VARIANT_ID)) {
        hasTarget = true;
        break;
      }
    }

    // ✅ 有商品 且 不包含目标 variant → 显示
    el.style.display = (t.item_count > 0 && !hasTarget) ? 'block' : 'none';
  });
} catch (e) {}
 
                }
            }, {
                key: "addItemToCartHandler",
                value: function(t) {
                    return this.displayModal ? this.fetchAndOpenModal(t) : this.fetchAndOpenCart()
                }
            },{
                key: "ajaxRequestFail",
                value: function() {
                    this.openFailModal(), this.openCartOverlay()
                }
            }, {
                key: "renderCartModal",
                value: function(t) {
                    this.clearCartModal();
                    var e = t.variant_title;
                    e = null === e ? "" : "(".concat(e, ")");
                    var r = '\n        <div class="go-cart-modal-item">\n            <div class="go-cart-item__image" style="background-image: url('.concat(t.image, ');"></div>\n            <div class="go-cart-item__info">\n                <a href="').concat(t.url, '" class="go-cart-item__title">').concat(t.product_title, " ").concat(e, "</a> ").concat(this.labelAddedToCart, "\n            </div>\n        </div>\n      ");
                    this.cartModalContent.innerHTML += r
                }
            }, {
                key: "renderDrawerCart",
                value: function(t) {
var e = this;
e.clearCartDrawer();
e.__cartRenderToken = (e.__cartRenderToken || 0) + 1;
var renderToken = e.__cartRenderToken;
var drawerHtml = [];
var productMetaTasks = [];
var JNC_productCache = window.__JNC_productCache || (window.__JNC_productCache = {});

function JNC_drawerImageUrl(src) {
  try {
    if (!src) return "";
    var url = String(src);
    if (/[?&]width=/.test(url)) return url;
    return url + (url.indexOf("?") === -1 ? "?" : "&") + "width=80&height=80";
  } catch (err) {
    return src || "";
  }
}

function JNC_getProduct(handle) {
  if (!handle) return null;
  if (JNC_productCache[handle]) return JNC_productCache[handle];
  JNC_productCache[handle] = $.ajax({
    url: '/products/' + handle + '.js',
    dataType: 'json'
  }).then(function(product) {
    JNC_productCache[handle] = product;
    return product;
  }, function() {
    delete JNC_productCache[handle];
    return null;
  });
  return JNC_productCache[handle];
}

function JNC_getProductMeta(item, product) {
  var product_weight = '';
  var t_compare = 0;
  var metafields = (window.dishMetaFields && window.dishMetaFields[item.handle]) || null;
  product_weight = (metafields && metafields.product_weight) ? metafields.product_weight : '';

  if (product && product.variants) {
    product.variants.forEach(function(variant) {
      if (variant.compare_at_price != null && variant.id == item.variant_id) {
        t_compare = variant.compare_at_price * item.quantity;
      }
    });

    if (!product_weight) {
      var v = product.variants.find(function(v){ return v.id == item.variant_id; });
      var grams = v && (typeof v.grams === 'number' ? v.grams : 0);
      if (grams > 0) {
        product_weight = grams >= 1000
          ? (grams / 1000).toFixed(2) + ' kg'
          : grams + ' g';
      }
    }
  }

  return { product_weight: product_weight, t_compare: t_compare };
}

function JNC_updateProductMeta(row, item, product) {
  if (e.__cartRenderToken !== renderToken || !product) return;
  var meta = JNC_getProductMeta(item, product);
  var itemEl = e.cartDrawerContent.querySelector('.go-cart-item__single[data-line="' + row.originalLine + '"]');
  if (!itemEl) return;

  var weightEl = itemEl.querySelector('.product_weight');
  if (weightEl) weightEl.textContent = meta.product_weight || '';

  var compareEl = itemEl.querySelector('.compare_price[data-jnc-compare="1"]');
  if (meta.t_compare != 0) {
    if (!compareEl) {
      compareEl = document.createElement('div');
      compareEl.className = 'compare_price';
      compareEl.setAttribute('data-jnc-compare', '1');
      var priceEl = itemEl.querySelector('.go-cart-item__price');
      if (priceEl) itemEl.insertBefore(compareEl, priceEl);
    }
    compareEl.innerHTML = formatMoney(meta.t_compare, e.moneyFormat);
    compareEl.style.display = '';
  } else if (compareEl) {
    compareEl.innerHTML = '';
    compareEl.style.display = 'none';
  }
}

// 判断所有商品是否都是赠品（通过 properties.Gift 判断）
  // let allItemsAreGifts = t.items.every(item => item.properties?._gift);
// 判断所有商品是否都是赠品（通过 properties.Gift 判断）
  // let allItemsAreGifts = t.items.every(item => item.properties?._gift);
  let giftItemCount = t.items.filter(item => item.properties?._gift).length;

// === allsips: 购物车显示顺序 ===
// 1) 赠品（带 _gift）放最前面
// 2) 免费产品（0元，但不是 _gift）放第二位
// 3) 其他正常付费商品保持原顺序
// 注意：排序后 data-line 仍必须用 Shopify 原始 line 编号，否则删除/改数量会操作错商品
function JNC_isGiftLine(item) {
  return !!(item && item.properties && item.properties._gift !== undefined);
}

function JNC_isZeroPriceLine(item) {
  var price = (typeof item.final_line_price === 'number')
    ? item.final_line_price
    : item.line_price;

  return Number(price || 0) === 0;
}

function JNC_sortPriority(item) {
  if (JNC_isGiftLine(item)) return 0;
  if (JNC_isZeroPriceLine(item)) return 1;
  return 2;
}

var displayItems = (t.items || []).map(function(item, index) {
  return {
    item: item,
    originalLine: index + 1,
    originalIndex: index
  };
}).sort(function(a, b) {
  var pa = JNC_sortPriority(a.item);
  var pb = JNC_sortPriority(b.item);

  if (pa !== pb) return pa - pb;
  return a.originalIndex - b.originalIndex;
});

// 遍历每个购物车项
displayItems.forEach(function(row) {
    var t = row.item;
    var r = row.originalLine - 1;
    var drawerImage = JNC_drawerImageUrl(t.image);
    var drawerImagePreload = drawerImage ? `<img src="${drawerImage}" alt="" aria-hidden="true" decoding="async" loading="eager" fetchpriority="high" style="position:absolute;width:1px;height:1px;opacity:0;pointer-events:none;">` : '';
    // 清理标题与变体信息
    let clean_product_title = t.product_title.replace(/ - Default Title$/, '');
    let a = formatOptions(t).replace(/Default Title/, '');

    var product_handle = t.handle;
    var cachedProduct = JNC_productCache[product_handle];
    var productMeta = (cachedProduct && cachedProduct.variants) ? JNC_getProductMeta(t, cachedProduct) : JNC_getProductMeta(t, null);
    var product_weight = productMeta.product_weight;
    var t_compare = productMeta.t_compare;
  // 判断当前项是否为赠品（用 _gift）
    let isGift = t.properties?._gift !== undefined;
    let showGiftNote = false;
  
    if (isGift) {
      if (giftItemCount < 2 || t.line_price === 0) {
        showGiftNote = true;
      }
    }
  
    // 设置样式类：黑色为默认，灰色为 muted
    let giftNoteClass = t.line_price === 0 ? 'gift-note-black' : 'gift-note-gray';
    
    let gift_note = showGiftNote
      ? `<div class="go-cart-item__gift-note ${giftNoteClass}">${t.properties._gift}</div>`
      : '';

      // 如果购物车里有这个 variant，在标题下面显示库存提示
const FEW_LEFT_VARIANT_ID = 41734317768837;
let few_left_note = Number(t.variant_id) === FEW_LEFT_VARIANT_ID
  ? `<div class="go-cart-item__few-left">a few left</div>`
  : '';
    // 获取产品的 compare_at_price 和 metafields
    // $.ajax({
    //     url: '/products/' + t.handle + '.js',
    //     dataType: 'json',
    //     async: false,
    //     success: function(product) {
    //         product.variants.forEach(function(variant) {
    //             if (variant.compare_at_price != null && variant.id == t.variant_id) {
    //                 t_compare = variant.compare_at_price * t.quantity;
    //             }
    //         });
    //         var metafields = dishMetaFields[product_handle];
    //         product_weight = metafields.product_weight;
    //     }
    // });
    if (!(cachedProduct && cachedProduct.variants)) {
      productMetaTasks.push({ row: row, item: t, handle: product_handle });
    }

    var compare_price = t_compare != 0 ? `<div class='compare_price' data-jnc-compare="1">${formatMoney(t_compare, e.moneyFormat)}</div>` : '<div class="compare_price" data-jnc-compare="1" style="display:none;"></div>';

    // 生成数量选择框（桌面和手机分别处理）
    const qty = t.quantity;
    const quantityOptions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 15, 20, 25, 30];
    
    let quantity_select_desktop = `<div class="quantity_select quantity_select-desktop"><select class="quantity_custom_select js-go-cart-quantity-quantity-update">`;
    let quantity_select_mobile = `<div class="quantity_select quantity_select-mobile"><select class="quantity_custom_select js-go-cart-quantity-quantity-update">`;

    quantityOptions.forEach(opt => {
        let selected = opt === qty ? ' selected' : '';
        quantity_select_desktop += `<option value="${opt}"${selected}>${opt}</option>`;
        quantity_select_mobile += `<option value="${opt}"${selected}>${opt}</option>`;
    });

    if (!quantityOptions.includes(qty)) {
        quantity_select_desktop += `<option value="${qty}" selected>${qty}</option>`;
        quantity_select_mobile += `<option value="${qty}" selected>${qty}</option>`;
    }

    quantity_select_desktop += `</select></div>`;
    quantity_select_mobile += `</select></div>`;

    // 构建 HTML 输出
    let o = `
    <div class="go-cart-item__single" data-line="${row.originalLine}">
      <div class="go-cart-item__info-wrapper">
        <div class="go-cart-imgwrap">
          <div class="go-cart-item__image" style="background-image: url(${drawerImage});">${drawerImagePreload}</div>
          <span class="reddot-cart-${t.id}"></span>
        </div>
        <div class="go-cart-item__info">
          <a href="${t.url}" class="go-cart-item__link">
            <div class="go-cart-item__title">${clean_product_title}</div>
            ${gift_note}
            ${few_left_note}
            <div class="AA go-cart-item__variant">${a}<span class="product_weight">${product_weight}</span></div>
          </a>
          ${quantity_select_mobile}
          <div class="go-cart-item__quantity">
            <div class="go-cart-item__quantity-wrapper">
              <button class="go-cart-item__quantity-button js-go-cart-quantity-minus" aria-label="decrease quantity">${gocartIcons.minus}</button>
              <input class="go-cart-item__quantity-number js-go-cart-quantity" type="number" value="${t.quantity}" disabled>
              <button class="go-cart-item__quantity-button js-go-cart-quantity-plus" aria-label="increase quantity">${gocartIcons.plus}</button>
            </div>
          </div>
        </div>
      </div>
      ${quantity_select_desktop}
      ${compare_price}
      <div class="go-cart-item__price">${formatMoney(t.line_price, e.moneyFormat)}</div>
      <button aria-label="Remove Item From Cart" title="Remove item from cart" class="go-cart-item__remove ${e.removeFromCartNoDot}">${gocartIcons.close}</button>
    </div>
    `;

    drawerHtml.push(o);
});

e.cartDrawerContent.innerHTML = drawerHtml.join('');
productMetaTasks.forEach(function(task) {
  var productRequest = JNC_getProduct(task.handle);
  if (productRequest && typeof productRequest.then === 'function') {
    productRequest.then(function(product) {
      JNC_updateProductMeta(task.row, task.item, product);
    });
  } else {
    JNC_updateProductMeta(task.row, task.item, productRequest);
  }
});

// 更新小计及绑定交互事件
e.cartDrawerSubTotal.innerHTML = formatMoney(t.total_price, e.moneyFormatSub) + '&nbsp;&nbsp;<span class="total-original-price" style="display:none;">' + (t.original_total_price > t.total_price ? formatMoney(t.original_total_price) : '') + '</span>';
e.cartDrawerSubTotal.parentNode.classList.remove("is-invisible");

// 删除项事件绑定
document.querySelectorAll(e.removeFromCart).forEach(function(t) {
    t.addEventListener("click", function() {
        GoCart.removeItemAnimation(t.parentNode);
        var r = t.parentNode.getAttribute("data-line");
        e.removeItem(r);
    });
});

// 增加数量按钮事件绑定
document.querySelectorAll(e.itemQuantityPlus).forEach(function(t) {
    t.addEventListener("click", function() {
        var r = t.closest(".go-cart-item__single").getAttribute("data-line");
        var a = Number(t.closest(".go-cart-item__quantity-wrapper").querySelector(e.itemQuantity).value) + 1;
        e.changeItemQuantity(r, a);
    });
});

// 减少数量按钮事件绑定
document.querySelectorAll(e.itemQuantityMinus).forEach(function(t) {
    t.addEventListener("click", function() {
        var wrapper = t.closest(".go-cart-item__single");
        var r = wrapper.getAttribute("data-line");
        var qtyInput = t.closest(".go-cart-item__quantity-wrapper").querySelector(e.itemQuantity);
        var a = Number(qtyInput.value) - 1;
        e.changeItemQuantity(r, a);
        if (a === 0) GoCart.removeItemAnimation(wrapper);
    });
});

// 自定义数量选择更新
document.querySelectorAll(e.itemQuantityUpdate).forEach(function(t) {
    t.addEventListener("change", function() {
        var a = $(this).val();
        var r = t.closest(".go-cart-item__single").getAttribute("data-line");
        e.changeItemQuantity(r, a);
    });
});
    // 进度条更新
try {
    const cartTotal = parseFloat(t.items_subtotal_price) / 100;
    updateProgressBar(cartTotal);
} catch (e) {
    console.error("Progress bar error:", e);
}

                    
                }
            }, {
                key: "renderMiniCart",
                value: function(t) {
                    var e = this;
                    this.clearMiniCart(), t.items.forEach((function(t, r) {
                        var a = t.variant_title;
                        null === a && (a = "");
                        var o = '\n        <div class="go-cart-item__single" data-line="'.concat(Number(r + 1), '">\n            <div class="go-cart-item__info-wrapper">\n                <div class="go-cart-item__image" style="background-image: url(').concat(t.image, ');"></div>\n                <div class="go-cart-item__info">\n                    <a href="').concat(t.url, '" class="go-cart-item__title">').concat(t.product_title, '</a>\n                    <div class="go-cart-item__variant">').concat(a, '</div>\n                    <div class="go-cart-item__quantity">\n                        <span class="go-cart-item__quantity-label">').concat(e.labelQuantity, ' </span>\n                        <span class="go-cart-item__quantity-button js-go-cart-quantity-minus">-</span>\n                        <input class="go-cart-item__quantity-number js-go-cart-quantity" type="number" value="').concat(t.quantity, '" disabled>\n                        <span class="go-cart-item__quantity-button js-go-cart-quantity-plus">+</span>\n                    </div>\n                </div>\n            </div>\n            <div class="go-cart-item__price">').concat(formatMoney(t.line_price, e.moneyFormat), '</div>\n            <a class="go-cart-item__remove ').concat(e.removeFromCartNoDot, '">').concat(e.labelRemove, "</a>\n        </div>\n      ");
                        e.cartMiniCartContent.innerHTML += o
                    })), this.cartMiniCartSubTotal.innerHTML = formatMoney(t.total_price, this.moneyFormat), this.cartMiniCartSubTotal.parentNode.classList.remove("is-invisible"), document.querySelectorAll(this.removeFromCart).forEach((function(t) {
                        t.addEventListener("click", (function() {
                            GoCart.removeItemAnimation(t.parentNode);
                            var r = t.parentNode.getAttribute("data-line");
                            e.removeItem(r)
                        }))
                    })), document.querySelectorAll(this.itemQuantityPlus).forEach((function(t) {
                        t.addEventListener("click", (function() {
                            var r = t.parentNode.parentNode.parentNode.parentNode.getAttribute("data-line"),
                                a = Number(t.parentNode.querySelector(e.itemQuantity).value) + 1;
                            e.changeItemQuantity(r, a)
                        }))
                    })), document.querySelectorAll(this.itemQuantityMinus).forEach((function(t) {
                        t.addEventListener("click", (function() {
                            var r = t.parentNode.parentNode.parentNode.parentNode.getAttribute("data-line"),
                                a = Number(t.parentNode.querySelector(e.itemQuantity).value) - 1;
                            e.changeItemQuantity(r, a), 0 === Number(t.parentNode.querySelector(e.itemQuantity).value - 1) && GoCart.removeItemAnimation(t.parentNode.parentNode.parentNode.parentNode)
                        }))
                    }))
                }
            }, {
                key: "renderBlankCartDrawer",
                value: function() {
                    this.cartDrawerSubTotal.parentNode.classList.add("is-invisible"), this.clearCartDrawer(), this.cartDrawerContent.innerHTML = '<div class="go-cart__empty">'.concat(this.labelCartIsEmpty, "</div>"),
                    c = $('.cart-extra').html();
                     this.cartDrawerContent.innerHTML= '<div class="go-cart__empty">'.concat(this.labelCartIsEmpty, "</div>");
                    $('.cart-title').text('Your Cart Is Empty');
                    $('.go-cart-drawer__content').css('border-bottom','0px'); 
                    $('.go-cart-drawer__content').css('padding-bottom','0px');
                    $('.drawer-main').addClass('main-drawer-empty');
                     $('.recom_main').css('display','none');
                    $('.footer-cart-drawer').css('display','none');
                        $('.cart_best_selling').css('display','block');
                            // 进度条更新（空购物车）
try {
  updateProgressBar(0);
} catch (e) {
  console.error("Progress bar error:", e);
}
                }
            }, {
                key: "renderBlankMiniCart",
                value: function() {
                    this.cartMiniCartSubTotal.parentNode.classList.add("is-invisible"), this.clearMiniCart(), this.cartMiniCartContent.innerHTML = '<div class="go-cart__empty">'.concat(this.labelCartIsEmpty, "</div>")
                }
            }, {
                key: "clearCartDrawer",
                value: function() {
                    this.cartDrawerContent.innerHTML = ""
                }
            }, {
                key: "clearMiniCart",
                value: function() {
                    this.cartMiniCartContent.innerHTML = ""
                }
            }, {
                key: "clearCartModal",
                value: function() {
                    this.cartModalContent.innerHTML = ""
                }
            }, {
                key: "openCartDrawer",
                value: function() {
                    var drawer = this.cartDrawer;
                    if (!drawer) return;
                    this.cartDrawer.classList.add("is-open");
                    this.htmlElement.classList.add("overflowy");
                    this.bodyElement.classList.add("overflowy");
                    drawer.addEventListener('transitionend', () => {
                        let cart = drawer instanceof Element ? drawer : document.querySelector('.go-cart__drawer');
                        if (!cart || !(cart instanceof Element)) return;
                        if (typeof cart.focus === 'function') cart.focus();
                        if (typeof trapFocus === 'function') trapFocus(cart);
                    }, { once: true });
                }
            }, {
                key: "closeCartDrawer",
                value: function() {
                    if (this.cartDrawer) this.cartDrawer.classList.remove("is-open")
                    if (this.htmlElement) this.htmlElement.classList.remove("overflowy");
                    if (this.bodyElement) this.bodyElement.classList.remove("overflowy");
                    if (typeof removeTrapFocus === 'function') removeTrapFocus(document.querySelector('body'));
                  var cartIconBubble = document.getElementById('cart-icon-bubble');
                  if (cartIconBubble && typeof cartIconBubble.focus === 'function') cartIconBubble.focus();
                }
            }, {
                key: "openMiniCart",
                value: function() {
                    this.cartMiniCart.classList.add("is-open")
                }
            }, {
                key: "closeMiniCart",
                value: function() {
                    this.cartMiniCart.classList.remove("is-open")
                }
            }, {
                key: "openFailModal",
                value: function() {
                    
                }
            }, {
                key: "closeFailModal",
                value: function() {
                    this.cartModalFail.classList.remove("is-open")
                }
            }, {
                key: "openCartModal",
                value: function() {
                    this.cartModal.classList.add("is-open")
                }
            }, {
                key: "closeCartModal",
                value: function() {
                    this.cartModal.classList.remove("is-open")
                }
            }, {
                key: "openCartOverlay",
                value: function() {
                    this.cartOverlay.classList.add("is-open")
                }
            }, {
                key: "closeCartOverlay",
                value: function() {
                    this.cartOverlay.classList.remove("is-open")
                }
            }, {
                key: "setDrawerDirection",
                value: function() {
                    this.cartDrawer.classList.add("go-cart__drawer--".concat(this.drawerDirection))
                }
            }, {
                key: "isDrawerMode",
                get: function() {
                    return "drawer" === this.cartMode
                }
            }]) && _defineProperties(t.prototype, e), r && _defineProperties(t, r), GoCart
        }();
        e.default = h
    }]).default
  }));
